import apiUrl from '../config/apiUrl';
import fetchUrl from '../utils/fetchUrl';

export const CARDS = async () => {
  return await fetchUrl({
    url: `${apiUrl}kyc/card`,
    method: 'GET',
  });
};
export const DELETE_CARDS = async (deleteId: number) => {
  return await fetchUrl({
    url: `${apiUrl}kyc/card/${deleteId}`,
    method: 'DELETE',
  });
};
export const ADD_CARDS = async (cardNumber: string) => {
  return await fetchUrl({
    url: `${apiUrl}kyc/card`,
    method: 'POST',
    body: {
      cardNumber,
    },
  });
};
export const VERIFY_CARDS = async (id: number) => {
  return await fetchUrl({
    url: `${apiUrl}kyc/card/verifyCard/${id}`,
    method: 'GET',
    body: {},
  });
};
